import { useState } from "react";
import Button from "../../../components/button";
import { CommentOutlined } from "../../../components/icons/comment-outlined";
import { DocumentOutlined } from "../../../components/icons/document-outlined";
import { StackOutlined } from "../../../components/icons/stack-outlined";
import { TimeOutlined } from "../../../components/icons/time-outlined";
import {
  dateFormatter,
  fractionOfDayToTimeString,
  timeFormatter,
} from "../../../core/utils";
import { ReportResponse } from "../../../redux/features/report-slice";
import UpdateReportDialog from "../../daily-report/components/update-report-dialog";
import { TagFilled } from "../../../components/icons/tag-filled";

interface Props {
  reports: ReportResponse[];
  onRefresh: () => void;
}

export default function TaskGroupReportsTable(props: Props) {
  const { reports, onRefresh } = props;

  const [selectedReport, setSelectReport] = useState<ReportResponse | null>(
    null
  );

  return (
    <>
      <ol className="m-4 relative border-s border-divider">
        {reports.map((report: ReportResponse) => (
          <li key={report.id} className="mb-8 ms-4">
            <div className="absolute w-3 h-3 bg-divider rounded-full mt-1 -start-1.5" />
            <div className="flex items-center justify-between">
              <div className="w-10/12 space-y-2">
                <time className="w-10/12 text-sm font-normal  text-text-title">
                  {`${dateFormatter(report.date, "EEEE dd/MM/yyyy")} ${
                    report.startTime && report.endTime
                      ? `${timeFormatter(report.startTime)} - ${timeFormatter(
                          report.endTime
                        )}`
                      : ""
                  }`}
                </time>
                <p className="text-sm italic">
                  {`${report.detail !== "" ? report.detail : "..."}`}
                </p>
                <div className="flex items-center justify-start space-x-4 overlow-x-hidden">
                  {report.tag && (
                    <TagFilled
                      className="w-4 h-4"
                      style={{
                        color: report.tag.split("-")[1],
                      }}
                    />
                  )}
                  <label
                    title="Duration"
                    className="w-fit flex items-center text-sm space-x-1 text-text-title whitespace-nowrap"
                  >
                    <TimeOutlined className="w-4 h-4 text-text-title" />
                    <label>{report.duration}</label>
                  </label>
                  <label
                    title="Quantity"
                    className="w-fit flex items-center text-sm space-x-1 text-text-title whitespace-nowrap"
                  >
                    <StackOutlined className="w-4 h-4 text-text-title" />
                    <label>{report.quantity}</label>
                  </label>
                  <label
                    title="Avg. Time"
                    className="w-fit flex items-center text-sm space-x-1 text-text-title whitespace-nowrap"
                  >
                    <label>
                      {`Avg. Time ${fractionOfDayToTimeString(
                        report.duration /
                          (report.quantity !== 0 ? report.quantity : 1)
                      )}`}
                    </label>
                  </label>
                </div>
                {report.comments && (
                  <div className="flex items-center space-x-2">
                    <CommentOutlined className="h-4 w-4 text-text-title" />
                    <label className="text-sm text-text-title">
                      {report.comments}
                    </label>
                  </div>
                )}
                {report.notes && (
                  <div className="flex items-center space-x-2">
                    <DocumentOutlined className="h-4 w-4 text-text-title" />
                    <label className="text-sm text-text-title">
                      {report.notes}
                    </label>
                  </div>
                )}
              </div>
              <Button
                variant="outlined"
                label="See Details"
                onClick={() => setSelectReport(report)}
                exClassName="truncate w-fit"
              />
            </div>
          </li>
        ))}
      </ol>
      <UpdateReportDialog
        report={selectedReport}
        setReport={setSelectReport}
        onCompleted={onRefresh}
      />
    </>
  );
}
